<header class="col-12 header-page">
  <h1 class="header__page__content__title">
    Painel de Saúde
  </h1>
</header>
<main class="col-xl-12 px-2 main__content">
  <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formData">
    <section class="content-form">
      <div class="col-xl-5 col-lg-7 p-0">
        <label class="content__form__title__label" for="ano">Selecione o ano que deseja consultar</label>
        <ng-select [items]="anos" bindLabel="name" bindValue="id" placeholder="Selecione um ano" [clearable]="false" [searchable]="false" [loading]="loading"
          (change)="anoSelecionado($event)" formControlName="ano">
        </ng-select>
      </div>
    </section>
  </form>
  <section class="d-flex container-cards">
    <section class="col-xl-12 col-12 px-0 card-container">
      <section class="card" [@fadeIn]>
        <span class="content__card__title">
          Mensalidade Atual
        </span>
        <p class="content__card__content">
          <img class="card__content__icon" src="../../../../../../assets/img/svg/MENSALIDADE.svg" />
          <span [@loadingValue]>

            <ng-container *ngIf="loading; else dataLoaded">
              <div class="loading-spinner"></div>
            </ng-container>
            
            <ng-template #dataLoaded>
              <ng-container *ngIf="mensalidadeAtual; else mensalidade">
                {{ mensalidadeAtual | async | currency: 'BRL' }}
              </ng-container>
            
              <ng-template #mensalidade>
                {{ 0 | currency: 'BRL' }}
              </ng-template>
            </ng-template>
            

            <span class="fa-icon-dashboard fa-coin">$</span>
          </span>
        </p>
      </section>
      <section class="card" [@fadeIn]>
        <span class="content__card__title">
          Total utilizado
        </span>
        <p class="content__card__content">
          <img class="card__content__icon" src="../../../../../../assets/img/svg/TOTAL.svg" />
          <span [@loadingValue]>

            <ng-container *ngIf="loading; else carregando">
              <div class="loading-spinner"></div>
            </ng-container>

            <ng-template #carregando>
              {{totalUtilizado | async | currency:'BRL'}}
            </ng-template>

            <span class="fa-icon-dashboard fa-coin">$</span>
          </span>
        </p>
      </section>
      <section class="card" [@fadeIn]>
        <span class="content__card__title">
          Patrocinadora
        </span>
        <p class="content__card__content">
          <img class="card__content__icon" src="../../../../../../assets/img/svg/SUBSÍDIO.svg" />
          <span [@loadingValue]>

            <ng-container *ngIf="loading; else patrocionio">
              <div class="loading-spinner"></div>
            </ng-container>

            <ng-template #patrocionio>
              <span>{{ patrocinadora | async | currency:'BRL' }}</span>
            </ng-template>

            <!-- <fa-icon class="fa-icon-dashboard" size="5x" [icon]="faLine"></fa-icon> -->
            <span class="fa-icon-dashboard fa-coin">$</span>
          </span>
        </p>
      </section>
      <section class="card" [@fadeIn]>
        <span class="content__card__title">
          <span>Coparticipação</span>
        </span>
        <p class="content__card__content">
          <img class="card__content__icon" src="../../../../../../assets/img/svg/COPARTICIPAÇÃO.svg" />
          <span [@loadingValue]>

            <ng-container *ngIf="loading; else cooparticipacao">
              <div class="loading-spinner"></div>
            </ng-container>

            <ng-template #cooparticipacao>
            {{coparticipacao | async | currency:'BRL'}}
            </ng-template>
            <!-- <fa-icon class="fa-icon-dashboard" size="5x" [icon]="faLine"></fa-icon> -->
            <span class="fa-icon-dashboard fa-coin">$</span>
          </span>
        </p>
      </section>
    </section>
  </section>
  <section class="row">
  </section>
  <section class="main__graficos row" [@fadeIn]>
    <section class="main__graficos__gastos col-sm-12 col-md-12 col-lg-7 col-xl-7 px-2 mt-3" [@fadeIn]>
      <h3 class="title-composicao-reserva">Gasto em utilizações até hoje (desde {{formData.get('ano')?.value}})</h3>
      <br>
      <section>
        <section class="grid-container">
          <div class="grid-item-composicao">
            <span>Total</span>
            <br>
            <span>{{totalUtilizado | async | currency:'BRL'}}</span>
          </div>
          <div class="grid-item-composicao" *ngIf="anoSelecionadoSaude">
            <span>{{formData.get('ano')?.value}}</span>
            <br>
            <span>{{ anoSelecionadoSaude['total'] | currency:'BRL' }}</span>
          </div>
          <div class="grid-item-composicao">
            <span>Percentual %</span>
            <br>
            <span>100%</span>
          </div>
        </section>
        <canvas id="piechart"></canvas>
      </section>
    </section>
    <section class="main__graficos__gastos__pie col-sm-12 col-md-12 col-lg-5 col-xl-5 px-2 mt-3" [@fadeIn]>
      <h3>Total utilizado
        <!-- (desde {{formData.get('ano')?.value}}) -->
      </h3>
      <br>
      <section>
        <section class="content-cards-info">
          <section *ngFor="let pessoa of costs.person" [@fadeIn]>
            <div class="card-info">
              <div>
                <p class="card-info-nome mb-1">{{pessoa.name}}</p>
                <p class="card-info-valor">{{pessoa.total | currency:'BRL'}}</p>
              </div>
              <div>
                <p class="card-info-porcentagem">
                  {{(pessoa.total/totalValorPercent) * 100 | percentage}}
                </p>
              </div>
            </div>
          </section>
        </section>
      </section>
    </section>
  </section>
  <section class="main__graficos row">
    <section class="main__graficos__gastos col-sm-12 col-md-12 col-lg-6 col-xl-6 px-2 mt-3" [@fadeIn]>
      <h3>Pagamentos efetuados pela Fundação Copel ({{formData.get('ano')?.value}})</h3>
      <br>
      <section>
        <section class="grid-container">
          <div class="grid-item">
            <span>Total</span>
            <br>
            <span>{{patrocinadora | async | currency:'BRL'}}</span>
          </div>
          <div class="grid-item" *ngIf="anoSelecionadoSaude">
            <span>{{formData.get('ano')?.value}}</span>
            <br>
            <span>{{ anoSelecionadoSaude['sponsorTotal'] | currency:'BRL' }}</span>
          </div>
          <div class="grid-item" *ngIf="anoSelecionadoSaude">
            <span>Percentual %</span>
            <br>
            <span>{{(anoSelecionadoSaude['sponsorTotal']/anoSelecionadoSaude['total']) * 100 | percentage}}</span>
          </div>
        </section>
        <canvas id="teste"></canvas>
      </section>
    </section>
    <section class="main__graficos__gastos col-sm-12 col-md-12 col-lg-6 col-xl-6 px-2 mt-3" [@fadeIn]>
      <h3>Seus pagamentos em coparticipação ({{formData.get('ano')?.value}})</h3>
      <br>
      <section>
        <section class="grid-container">
          <div class="grid-item">
            <span>Total</span>
            <br>
            <span>{{coparticipacao | async | currency:'BRL'}}</span>
          </div>
          <div class="grid-item" *ngIf="anoSelecionadoSaude">
            <span>{{formData.get('ano')?.value}}</span>
            <br>
            <span>{{ anoSelecionadoSaude['paidTotal'] | currency:'BRL' }}</span>
          </div>
          <div class="grid-item" *ngIf="anoSelecionadoSaude">
            <span>Percentual %</span>
            <br>
            <span>{{(anoSelecionadoSaude['paidTotal']/anoSelecionadoSaude['total']) * 100 | percentage}}</span>
          </div>
        </section>
        <canvas id="actualChart"></canvas>
      </section>
    </section>
  </section>
  <section class="row">
    <section class="content_carencias col-xl-6 px-2">
      <h3 *ngIf="healthCardSide==1" [@fadeIn]>Dados do plano de saúde</h3>
      <h3 *ngIf="healthCardSide==2" [@fadeIn]>Prazo Máximo Carências</h3>
      <div id="carousel" class="carousel carousel-multi-item slide" data-ride="carousel">
        <h4 class="carousel-user-selecionado mb-2">{{beneficiaries[healthCardPerson]?.name}}</h4>
        <div class="carousel-inner" role="listbox">
          <a class="carousel-control-prev" (click)="prevBeneficiary()">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" (click)="nextBeneficiary()">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
          <ol class="carousel-indicators mb-0">
            <li *ngFor="let beneficiary of beneficiaries; let i = index" style="background-color: #ff9a72;"
              class="indicator" [class.active]="i === healthCardPerson" data-target="#carousel" data-slide=""
              (click)="changeBeneficiary(i)" [@fadeIn]>
            </li>
          </ol>
        </div>
      </div>
      <div class="content-carrousel">
        <div [@fadeIn]>
          <section class="mt-1">
            <section class="carousel-dados-plano-saude" *ngIf="healthCardSide == 1" [@fadeIn]>
              <div>
                <span>Nº Carteirinha</span>
                <p>{{beneficiaries[healthCardPerson]?.healthInsuranceCard ?? ' - '}}</p>
              </div>
              <div>
                <span>Nº Cartão Nacional de Saúde</span>
                <p>{{beneficiaries[healthCardPerson]?.nationalHealthCard ?? ' - '}}</p>
              </div>
              <div>
                <span>Nome do Plano</span>
                <p>{{beneficiaries[healthCardPerson]?.healthInsuranceName ?? ' - '}}</p>
              </div>
              <div>
                <span>Nº Matrícula do Plano</span>
                <p>{{beneficiaries[healthCardPerson]?.healthInsuranceRegistration ?? ' - ' }}</p>
              </div>
              <div>
                <span>Nome da Operadora</span>
                <p>{{beneficiaries[healthCardPerson]?.healthInsuranceCarrierName ?? ' - '}}</p>
              </div>
              <div>
                <span>Cód. da Operadora na ANS</span>
                <p>{{beneficiaries[0]?.healthInsuranceRegistrationANS ?? ' - '}}</p>
              </div>
              <div>
                <span>Nome Adm. Benefício</span>
                <p>{{beneficiaries[0]?.healthInsuranceAdministrator ?? ' 0 '}}</p>
              </div>
              <div>
                <span>Nome Empresa Contratante</span>
                <p>{{beneficiaries[0]?.company ?? ' - '}}</p>
              </div>
              <div>
                <span>Nº do Contrato</span>
                <p>{{beneficiaries[0]?.healthInsuranceContractNumber ?? ' - '}}</p>
              </div>
              <div>
                <span>Nº de Cadastro na ANS</span>
                <p>{{beneficiaries[0]?.healthInsuranceCarrierCodeANS ?? ' - '}}</p>
              </div>
              <div>
                <span>Tipo de Contratação</span>
                <p>{{beneficiaries[0]?.contractType ?? ' - '}}</p>
              </div>
              <div>
                <span>Tipo de Regulamentação</span>
                <p>{{beneficiaries[0]?.regulationType}}</p>
              </div>
              <div>
                <span>Data de Contratação</span>
                <p>{{beneficiaries[0]?.coverageInitialDate | date: 'dd/MM/yyyy'}}</p>
              </div>
              <div>
                <span>Inicio da Cobertura</span>
                <p>{{beneficiaries[0]?.coverageInitialDate | date: 'dd/MM/yyyy'}}</p>
              </div>
              <div>
                <span>Área de Abrangência</span>
                <p>{{beneficiaries[0]?.coverage ?? ' - '}}</p>
              </div>
              <div>
                <span>Fim da Cobertura Parcial Temp.</span>
                <p>{{beneficiaries[0]?.coveragePartialFinalDate| date:'dd/MM/yyyy'}}</p>
              </div>
              <div>
                <span>Segmentação Assistencial</span>
                <p>{{beneficiaries[0]?.careSegmentation ?? ' - '}}</p>
              </div>
              <div>
                <span>Padrão de Acomodação</span>
                <p>{{beneficiaries[0]?.accommodation ?? ' - '}}</p>
              </div>
            </section>
            <section class="carousel-dados-plano-saude-carencias" *ngIf="healthCardSide == 2" [@fadeIn]>
              <section class='row'>
                <div class="col-3 ">Início da Carência</div>
                <div class="col-3 ">Fim da Carência</div>
                <div class="col-6 ">Cobertura</div>
              </section>
              <section>
                <div class='row' *ngFor="let short of beneficiaries[healthCardPerson].shortage" [@fadeIn]>
                  <div class="col-3 ">{{short.start | date: 'dd/MM/yyyy'}}</div>
                  <div class="col-3 ">{{short.end | date: 'dd/MM/yyyy'}}</div>
                  <div class="col-6 ">{{short.name}}</div>
                </div>
                <div class="card-body text-left pb-0" *ngIf="!beneficiaries" [@fadeIn]>
                  <p>Nenhuma Carência Encontrada!</p>
                </div>
              </section>
            </section>
            <div class="col-12 mt-1">
              <a class="link-carencias" (click)="changeDados()" [@fadeIn]>
                {{healthCardSide == 1 ? 'Ver carências' : 'Ver Dados do Plano de Saúde' }}
              </a>
            </div>
          </section>
        </div>
      </div>
    </section>
  </section>
</main>